import React, { useState } from 'react';
import {
  Box,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  HStack,
  Select,
  Button
} from '@chakra-ui/react';
import { MdAdd } from 'react-icons/md';
import DynamicFormField from '@components/DynamicFormField/DynamicFormField';
import { CURRENCIES } from '@constants/v2/common';

/* -----------------------------------------------------
   Reusable Field Renderer
----------------------------------------------------- */
export const Field = ({ field, value, editable, onChange }) => (
  <DynamicFormField
    fieldConfig={{
      ...field,
      isEditable: editable,
      labelColor: 'gray.300',
      size: field.size || 'sm',
      width: '100%'
    }}
    data={{ [field.name]: value }}
    handleChange={onChange}
  />
);

/* -----------------------------------------------------
   Reusable Currency Accordion
----------------------------------------------------- */
export const CurrencyAccordion = ({ currencies, isEditMode, renderFields }) => {
  if (!currencies || Object.keys(currencies).length === 0) {
    return <Text color="gray.500">No currencies configured</Text>;
  }

  return (
    <Accordion allowMultiple defaultIndex={Object.keys(currencies).map((_, i) => i)}>
      {Object.entries(currencies).map(([currency, currencyData]) => (
        <AccordionItem
          key={currency}
          border="1px solid"
          borderColor="whiteAlpha.400"
          borderRadius="md"
          mb={2}
          bg="dark.400"
        >
          <AccordionButton _hover={{ bg: 'dark.500' }} py={2}>
            <Box flex="1" textAlign="left">
              <Text fontWeight="bold" fontSize="sm" color="white">
                {currency}
              </Text>
            </Box>
            <AccordionIcon color="brand.400" />
          </AccordionButton>

          <AccordionPanel bg="dark.300" p={3}>
            <HStack alignItems="center" gap={4} flexWrap="wrap">
              {renderFields(currency, currencyData)}
            </HStack>
          </AccordionPanel>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

/* -----------------------------------------------------
   Add Currency Dropdown Bar
----------------------------------------------------- */
export const AddCurrencyBar = ({ onAdd, existingCurrencies = {} }) => {
  const [value, setValue] = useState('');

  const availableCurrencies = Object.keys(CURRENCIES).filter(
    (currency) => !existingCurrencies[currency]
  );

  const handleAdd = () => {
    if (!value) return;
    onAdd(value);
    setValue('');
  };

  return (
    <HStack spacing={2}>
      <Select
        placeholder="Select currency"
        size="sm"
        width="150px"
        bg="dark.400"
        borderColor="whiteAlpha.400"
        color="white"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        sx={{
          option: {
            bg: 'dark.400',
            color: 'white'
          }
        }}
      >
        {availableCurrencies.map((currency) => (
          <option key={currency} value={currency}>
            {currency}
          </option>
        ))}
      </Select>
      <Button
        size="sm"
        colorScheme="brand"
        bg="brand.600"
        _hover={{ bg: 'brand.700' }}
        onClick={handleAdd}
        isDisabled={!value}
        leftIcon={<MdAdd size="1rem" />}
      >
        Add
      </Button>
    </HStack>
  );
};

export { CustomRatesCard } from './CustomRatesCard';
export { MarketRatesCard } from './MarketRatesCard';
export { GoogleRatesCard } from './GoogleRatesCard';
export { VanceFxRatesCard } from './VanceFxRatesCard';
